var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:({
    backgroundColor: _vm.inverted ? 'black' : 'white',
    border: _vm.borderLess || _vm.inverted ? 'none' : '1px solid #ddd',
    padding: _vm.borderLess ? '0' : '0 17px',
    color: _vm.inverted ? 'white !important' : 'black !important',
  }),attrs:{"type":_vm.type}},[(_vm.loading)?_c('span',[_c('i',{staticClass:"spin",staticStyle:{"height":"17px","padding":"0"},attrs:{"data-feather":"loader"}})]):_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }